<div class="experience-courses-accelerator-course-feedback-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="feedback()"></grid-content>
</div>